import { useNavigate } from 'react-router-dom';
import { AccessDeniedPage } from '@azyntor-labs/nexus-ui';
import { useExamAuth } from '@/hooks/useExamAuth';

export const AccessDenied = () => {
  const navigate = useNavigate();
  const { user, hasAnyRole } = useExamAuth();

  const getDashboardPath = () => {
    if (!user) return '/login';
    if (hasAnyRole(['system_admin', 'super_admin', 'admin'])) return '/admin/dashboard';
    if (hasAnyRole(['instructor', 'teacher'])) return '/teacher/dashboard';
    if (hasAnyRole(['proctor'])) return '/proctoring/monitor';
    return '/student/dashboard';
  };

  // Determine role label for display
  const getRoleLabel = () => {
    if (hasAnyRole(['system_admin', 'super_admin'])) return 'System Admin';
    if (hasAnyRole(['admin'])) return 'Admin';
    if (hasAnyRole(['instructor', 'teacher'])) return 'Teacher';
    if (hasAnyRole(['proctor'])) return 'Proctor';
    if (hasAnyRole(['student'])) return 'Student';
    return 'User';
  };

  return (
    <AccessDeniedPage
      user={user ? {
        email: user.email,
        role: getRoleLabel(),
      } : null}
      dashboardPath={getDashboardPath()}
      onGoHome={() => navigate(getDashboardPath())}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default AccessDenied;
